import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const CustomerPendingEnquiries = {
	name: NAME,
	apiProvider,
	router,
};
